<div class="tableheader">

  {{Title}}
</div>
<div class="tablewrap">
  <div class="table">
    <table fixedcols="[1]">
      <tr>
        <th>{{'Name'|translate}}</th>
        <th>
          <button [disabled]="readonly" class="btn_img btn_graygray btn_plusorange" (click)="onAddGroupClick()" title="{{'Add group'|translate}}"></button>
          <button [disabled]="readonly" class="btn_img btn_remove" (click)="onRemoveAllClick()" title="{{'Clear'|translate}}"></button>
        </th>
      </tr>
      <tr *ngFor="let groupId of Objects">
        <ng-template [ngTemplateOutlet]="templateRef" [ngTemplateOutletContext]="{$implicit: getItem(groupId)}"></ng-template>
        <td>
          <!--<button class="btn_img btn_edit"></button>-->
          <button [disabled]="readonly" class="btn_img btn_remove" (click)="removeFromGroup(getItem(groupId))"></button>
        </td>
      </tr>
    </table>
  </div>
</div>
<template #mgmtDialog></template>
